import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';

import { Skills } from '../../interfaces/interfaces';
import { ResumeService } from '../../services/resume.service';

interface Skill {
  skill?: string;
  rating?: number;
}

@Component({
  selector: 'app-add-skills',
  templateUrl: './add-skills.component.html',
  styleUrls: ['./add-skills.component.css']
})
export class AddSkillsComponent {
  public skills = {skills: [] as Array<Skill> } as Skills;
  public skillsList = [
    {skill: 'Add New', rating: 0},
    {skill: 'HTML/CSS', rating: 0},
    {skill: 'Python/Django', rating: 0},
    {skill: 'PHP/MySQL', rating: 0},
    {skill: 'JS/jQuery', rating: 0},
    {skill: 'ReactJS', rating: 0},
    {skill: 'Angular', rating: 0},
    {skill: 'Adaptable', rating: 0},
    {skill: 'Analytical', rating: 0},
    {skill: 'Client Retention', rating: 0},
    {skill: 'Communication', rating: 0},
    {skill: 'Conflict Resolution', rating: 0},
    {skill: 'Copywriting', rating: 0},
    {skill: 'CRM (Salesforce)', rating: 0},
    {skill: 'Data Analysis', rating: 0},
    {skill: 'Decision Making', rating: 0},
    {skill: 'Efficient', rating: 0},
    {skill: 'Event Planning', rating: 0},
    {skill: 'Flexible', rating: 0},
    {skill: 'Goal Oriented', rating: 0},
    {skill: 'Handling Pressure', rating: 0},
    {skill: 'Hard Working', rating: 0},
    {skill: 'Leadership', rating: 0},
    {skill: 'Microsoft Office', rating: 0},
    {skill: 'Multi-tasking', rating: 0},
    {skill: 'Persuasive', rating: 0},
    {skill: 'Problem Solving', rating: 0},
    {skill: 'Project Management', rating: 0},
    {skill: 'Quick Learner', rating: 0},
    {skill: 'Resourceful', rating: 0},
    {skill: 'Self-motivation', rating: 0},
    {skill: 'SEO/SEM Marketing', rating: 0},
    {skill: 'Social Media Campaigns', rating: 0},
    {skill: 'Teamwork', rating: 0},
  ];
  public theme_id;
  constructor(
    private router: Router,
    private resumeService: ResumeService,
    private localStorageService: LocalStorageService
  ) {
    const resume_id = this.localStorageService.get('resume_id').toString();
    this.skills.resume_id = resume_id;
    this.resumeService.getResumeById(resume_id).subscribe(res => {
      this.skills.skills = res.Resume.skills || [];
    });
    this.theme_id = this.localStorageService.get('theme_id') as string || 1;
  }
  addMore(skill?: Skill) {
    this.skills.skills.unshift(JSON.parse(JSON.stringify(skill)));
  }
  save() {
    this.resumeService.updateSkill(this.skills).subscribe(res => {
      this.skills.skills = res.resume.skills || [];
      // this.router.navigate(['/resume/lang']);
      this.goToTheme();
    }, err => {
      console.log(err);
    });
  }
  remove(skill) {
    const index = this.skills.skills.lastIndexOf(skill);
    this.skills.skills.splice(index, 1);
    this.resumeService.updateSkill(this.skills).subscribe(res => {
      this.skills.skills = res.resume.skills || [];
    }, err => {
      console.log(err);
    });
  }
  goToTheme () {
    const theme_id = this.localStorageService.get('theme_id') as string || 1;
    this.router.navigate(['/themes/' + theme_id]);
  }
}
